module.exports = __webpack_public_path__ + "static/media/aeroporto.b3262324.svg";